import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { UploadService } from '../../../services/upload/upload.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { documentInformation } from '../../../model/document.model';
import { RegionService } from '../../../services/region/region.service'
import { Region } from '../../../model/region.model'
import { ParInsuranceService } from '../../../services/par_insurance/par-insurance.service';
import { UploadEvent, UploadFile, FileSystemFileEntry } from 'ngx-file-drop';
import { Subject } from 'rxjs/Subject'
import { SearchTermservice } from '../../../services/search/search-service.service';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-par-insurance-dialogue',
  templateUrl: './par-insurance-dialogue.component.html',
  styleUrls: ['./par-insurance-dialogue.component.css']
})
export class ParInsuranceDialogueComponent implements OnInit {

  logFormData: any;
  submitSuccess;
  message;
  aidetails;
  statesList: any = [];
  data: any = {
    docid: '',
    insuranceid: '',
    policynum: '',
    phonenum: '',
    contact: '',
    insurancevendor: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalcode: '',
    expiration: Date,
    autoexpiration: Date,
    general_liability_occurance: '',
    wrongfull_liability_limit: '',
    workmas_comp_liability_limit: '',
    auto_liability_limit: '',
    garage_liability_limit: '',
    documentlink: '',
    PersonalAdvInjury: null,
    GeneralAggregate: null,
    ExcessLiability: null,
    ExcessLiabilityAggregate: null,
    WorkCompELEachAccident: null,
    WorkCompELDiseaseEachEmployee: null,
    WorkCompELDiseasePolicyLimit: null
  };
  documentInfo: documentInformation = new documentInformation();
  date;
  region = new Region();
  regions = [];
  states = [];
  allStates = [];
  iserror: boolean;
  errmsg: string;
  ziperror: boolean;
  errmessage: string;
  agentId: string;
  response = [];
  minDate = new Date();
  externalURL: any;
  onChangeFile: boolean = false;
  isFileChanged: boolean = false;
  onChangeFileName: string;
  updateFile: boolean = false;
  chooseFile: boolean = false;
  selectedRegion: any;
  errorMsg: boolean = false;
  isdatewrong: boolean;
  datewrongmsg: string;
  public files: UploadFile[] = [];
  loginId: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  uploadFlag : boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  refresh: Subject<any> = new Subject();
  placeholder = 'Select a State';
  previousValues: any = [];
  constructor(
    private changelogservice: ChangeLogService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private regionService: RegionService,
    private uploadService: UploadService,
    public search: SearchTermservice,
    private http: Http, private router: Router,
    private parinsuranceservice: ParInsuranceService,
    public dialogRef: MatDialogRef<ParInsuranceDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public pardata: any, public fb: FormBuilder, public ref: ChangeDetectorRef) {
    this.date = new FormControl(new Date());

  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.search.getListOfStates().subscribe(res => {
      this.statesList = res.States;
      this.statesList.forEach(state => {
        this.states.push(state.Code);
      });
    }, error => {
      this.errorMessage ="All States: " +error;
      this.errorEnable = true;
    })
    this.data.insuranceid = this.pardata.data.InsuranceId;
    this.data.documenttypename = this.pardata.data.DocumentTypeName;
    this.data.docid = this.pardata.data._id;
    this.data.documenttypecode = this.pardata.data.DocumentTypeCode;
    this.data.filename = this.pardata.data.FileName;
    if (this.pardata.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.parinsuranceservice.insdetails(this.data.docid).subscribe( data => {
          localStorage.setItem('old', JSON.stringify(data.InsuranceDetails[0]));
          let res = data.InsuranceDetails;
          this.data.insuranceid = res[0].InsuranceId;
          this.data.policynum = res[0].PolicyNumber;
          this.data.phonenum = res[0].Phone;
          this.data.contact = res[0].Contact;
          this.data.insurancevendor = res[0].Vendor;
          this.data.address1 = res[0].Address1;
          this.data.address2 = res[0].Address2;
          this.data.city = res[0].City;
          this.data.state = res[0].State;
          this.placeholder = res[0].State ? 'State' : 'Select a State';
          this.data.postalcode = res[0].PostalCode;
          this.data.expiration = res[0].ExpirationDate;
          this.data.autoexpiration = res[0].AutoLiabilityExpirationDate;
          this.data.generalliabilityoccurance = res[0].CommercialGeneralLiability;
          this.data.workmascompliabilitylimit = res[0].WorkmansCompLiabilityLimit;
          this.data.eo_cyber = res[0].EOCyber;
          this.data.crimefidelity = res[0].CrimeFidelity;
          this.data.autoliabilitylimit = res[0].AutoLiability;
          this.data.garageliabilitylimit = res[0].GarageKeepersLiability;
          this.data.cancellationnotice = res[0].CancellationNotice;
          this.data.documenttypename = res[0].DocumentTypeName;
          this.data.documenttypecode = res[0].DocumentTypeCode;
          this.data.filename = res[0].FileName;
          this.data.documentlink = res[0].DocumentLink;

          this.data.PersonalAdvInjury = res[0].PersonalAdvInjury;
          this.data.GeneralAggregate = res[0].GeneralAggregate;
          this.data.ExcessLiability = res[0].ExcessLiability;
          this.data.ExcessLiabilityAggregate = res[0].ExcessLiabilityAggregate;
          this.data.WorkCompELEachAccident = res[0].WorkCompELEachAccident;
          this.data.WorkCompELDiseaseEachEmployee = res[0].WorkCompELDiseaseEachEmployee;
          this.data.WorkCompELDiseasePolicyLimit = res[0].WorkCompELDiseasePolicyLimit;
        }, error => {
          this.errorMessage = "Par Insurance details :" +error;
          this.errorEnable = true;
          window.scrollTo(0, 0)
        })
    } else if (this.pardata.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }

  }


  placeholderChange(){
    this.placeholder = "State"
  }

  scrollTop(){
    const element = document.getElementById('scrollToTop');
    element.scrollIntoView();
  }

  clear() {
    this.dialogRef.close();
  }
  checkType() {
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Uploaded a" + ' ' +  this.pardata.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.filename = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    if (this.isFileChanged === false && this.pardata.type === 'update') {
      this.externalURL = this.data.DocumentLink;
      this.submit();
    }
    else {
      let today = new Date();
      const estTimeZone = 'America/New_York';
      let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');

      var filePath = "Par/" + "parInsuranceDocs/" + this.data.documenttypecode + "/";
      this.data.filename = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;

      let body = {

        "newFilePath" : this.newFilePath1
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
       this.signedUrl = res.Info;
       this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
        this.externalURL = this.newFilePath1;
        this.data.documentlink = this.externalURL;
        this.submit();
      });
      }, error => {
        this.errorMessage = "File upload: " +error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop()
      });
    }
  }



  submit() {
    this.submitSuccess = false;
    this.logFormData = {
      "document_type": this.pardata.data.DocumentTypeName,
      "document_category": this.pardata.data.DocumentCategory,
      "transaction_type": "Add",
      "modified_by" : this.loginId
    }
    const setTime = new Date(this.data.expiration);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = 'America/New_York';
    const format = 'YYYY-MM-DDTHH:🇲🇲:ss.SSSZ';
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }

    if (this.pardata.type === 'create') {
      this.parinsuranceservice.createNewParInsurance(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Created a" + ' ' +  this.pardata.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
          this.submitSuccess = true;
          this.message = 'Insurance Document Created Successfully';
          this.parinsuranceservice.load.next('success')
          this.dialogRef.close();
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
          this.errorMessage = 'PAR Change Logs' + ' ' + err;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop()
        });
          this.submitSuccess = true;
      }, error => {
        this.message = 'Insurance Document Not Created';
        this.parinsuranceservice.load.next('fail')
        this.errorMessage = "Create par Insurance: " +error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop()
      })
    } else {
      this.parinsuranceservice.updateparIns(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Updated a" + ' ' +  this.pardata.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
          this.submitSuccess = true;
          this.message = 'Agent Insurance Information Updated';
          this.parinsuranceservice.load.next('success')
          this.dialogRef.close();
          this.logFormData.document_category = this.pardata.Category;
          this.logFormData.transaction_type = "Edit";
          this.previousValues = localStorage.getItem('old');
          this.logFormData.previous_fields = JSON.parse(this.previousValues);
          this.logFormData.collection_name = "par_insurance";
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
          this.errorMessage = 'PAR Change Logs' + ' ' + err;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop()
        });
          this.submitSuccess = true;
      }, error => {
        this.message = 'Data is not updated';
          this.parinsuranceservice.load.next('fail')
          this.errorMessage = "Uodate par Insurance: " +error;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop()
      })
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/components/par-insurance/par-insurance-dialogue/par-insurance-dialogue.component.ts